import { render } from "./App.vue?vue&type=template&id=1bb7984e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1bb7984e&lang=less"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__